<div class="visionboard-item-more-actions-menu">
  <button
    mat-icon-button
    class="visionboard-item-button button-disable-hover-action-style"
    (click)="onMoreActionsClick($event)"
    matTooltip="Edit Item"
  >
    <mat-icon svgIcon="more_vert"></mat-icon>
  </button>
  <span
    #moreActionsMenuTrigger
    class="trigger"
    [matMenuTriggerFor]="menu"
    (menuClosed)="onMenuClose()"
  ></span>
</div>
<mat-menu #menu="matMenu">
  <button
    mat-menu-item
    (click)="onEditClick()"
  >
    Edit
  </button>
  <button
    mat-menu-item
    *ngIf="canDelete"
    (click)="onDeleteClick()"
  >
    Delete
  </button>
</mat-menu>
